import http from './axiosInstance'
import errorHandler from '../transformers/axiosErrors'
import { ApiResponse } from '@/types'

export const fetchReport = async (
  opportunityId: number
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.get(`/opportunities/${opportunityId}/report`)
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const enhanceOpportunity = async (
  opportunityId: number
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.get(`/opportunities/${opportunityId}/enhance`)
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}
